import { render, staticRenderFns } from "./VlanTaggedSelectMultipleItem.vue?vue&type=template&id=bce6e3ea&scoped=true&"
import script from "./VlanTaggedSelectMultipleItem.vue?vue&type=script&lang=ts&"
export * from "./VlanTaggedSelectMultipleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce6e3ea",
  null
  
)

export default component.exports